<template>
  <!--
    `last4Digits`, not just `giftCard`: a websocket event carries the card as a bare id,
    and the timeline endpoint's hydration degrades to no card at all on a subdomain
    error. Either way there is nothing to identify the card with, so render nothing
    rather than "A gift card ending in  was sent".
  -->
  <div class="message" v-if="giftCard && giftCard.last4Digits">
    <div class="row mt-1 mb-1 message internal">
      <div class="col mr--2">
        <div class="comment-body">
          <p class="comment-text d-inline">
            A gift card ending in {{ giftCard.last4Digits }} was sent
            <span v-if="formattedAmount">for {{ formattedAmount }}</span>
          </p>
          <span class="badge badge-soft-primary ml-1 mb-1 mt-n1">Gift Card</span>
          <div class="row">
            <div class="col-auto">
              <p class="comment-time">{{ created | moment('LT') }} {{ timezone }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-auto mt-2">
        <a href="javascript:;" class="btn btn-sm btn-rounded-circle btn-primary">
          <CreditCardIcon size="1.26x" style="color: white" class="mt--1"></CreditCardIcon>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { CreditCardIcon } from 'vue-feather-icons'

export default {
  name: 'GiftCardSentEvent',
  props: ['created', 'giftCard', 'timezone'],
  components: {
    CreditCardIcon
  },
  computed: {
    // `amount` arrives as integer CENTS for every provider, so this divides
    // unconditionally. It used to branch on `provider` because Shift4 cards were stored
    // in dollars and legacy Moneris cards in cents; the backend now persists cents for
    // both. Do not reintroduce a per-provider unit here or in OWA's gift-cards store.
    //
    // Empty string when the amount is missing or unparseable, which hides the
    // clause entirely — "ending in 1234" alone still identifies the card, and
    // "for $NaN" is worse than saying nothing.
    formattedAmount() {
      const amountCents = Number(this.giftCard && this.giftCard.amount)
      if (!isFinite(amountCents) || amountCents <= 0) return ''
      return `$${(amountCents / 100).toFixed(2)}`
    }
  }
}
</script>
